<template>
  <div>
    <b-card>
      <b-tabs content-class="mt-3">
        <b-tab
          title="درخواست های ارسال نشده"
          href="#gateway_g1634"
          @click="ClearError()"
        >
          <div>
            <b-alert variant="danger" :show="errors.length > 0">
              <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <b-alert variant="success" :show="success_errors.length > 0">
              <p v-for="x in success_errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <list-table
              :url="gateway_g1634.url"
              title="درخواست های ارسال نشده"
              :fields="gateway_g1634.fields"
              :params="gateway_g1634.params"
              :detailCallFun="gateway_g1634.detailCallFun"
              :detailCallFunType="gateway_g1634.detailCallFunType"
              @handle_function_call="SendRequest1634"
              :refreshData="gateway_g1634.refreshData"
            ></list-table>
          </div>
        </b-tab>
        <b-tab
          title="تعریف مشتری در شبکه پرداخت"
          href="#gateway_g1628"
          @click="ClearError()"
        >
          <div>
            <b-alert variant="danger" :show="errors.length > 0">
              <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <b-alert variant="success" :show="success_errors.length > 0">
              <p v-for="x in success_errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <list-table
              :url="gateway_g1628.url"
              title="تعریف مشتری در شبکه پرداخت"
              :fields="gateway_g1628.fields"
              :params="gateway_g1628.params"
              :detailCallFun="gateway_g1628.detailCallFun"
              :detailCallFunType="gateway_g1628.detailCallFunType"
              @handle_function_call="SendRequest1628"
              :refreshData="gateway_g1628.refreshData"
            ></list-table>
          </div>
        </b-tab>
        <b-tab
          title="مشتری تعریف شد"
          href="#gateway_g1629"
          @click="ClearError()"
        >
          <div>
            <b-alert variant="danger" :show="errors.length > 0">
              <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <b-alert variant="success" :show="success_errors.length > 0">
              <p v-for="x in success_errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <list-table
              :url="gateway_g1629.url"
              title="مشتری تعریف شد"
              :fields="gateway_g1629.fields"
              :params="gateway_g1629.params"
              :detailCallFun="gateway_g1629.detailCallFun"
              :detailCallFunType="gateway_g1629.detailCallFunType"
              @handle_function_call="SendRequest1629"
              :refreshData="gateway_g1629.refreshData"
            ></list-table>
          </div>
        </b-tab>
        <b-tab
          title="تعریف ترمینال در بانک"
          href="#gateway_g1630"
          @click="ClearError()"
        >
          <div>
            <b-alert variant="danger" :show="errors.length > 0">
              <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <b-alert variant="success" :show="success_errors.length > 0">
              <p v-for="x in success_errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <list-table
              :url="gateway_g1630.url"
              title="تعریف ترمینال در بانک"
              :fields="gateway_g1630.fields"
              :params="gateway_g1630.params"
              :detailCallFun="gateway_g1630.detailCallFun"
              :detailCallFunType="gateway_g1630.detailCallFunType"
              @handle_function_call="SendRequest1630"
              :refreshData="gateway_g1630.refreshData"
            ></list-table>
          </div>
        </b-tab>
        <b-tab
          title="تعریف ترمینال در شاپرک"
          href="#gateway_g1631"
          @click="ClearError()"
        >
          <div>
            <b-alert variant="danger" :show="errors.length > 0">
              <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <b-alert variant="success" :show="success_errors.length > 0">
              <p v-for="x in success_errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <list-table
              :url="gateway_g1631.url"
              title="تعریف ترمینال در شاپرک"
              :fields="gateway_g1631.fields"
              :params="gateway_g1631.params"
              :detailCallFun="gateway_g1631.detailCallFun"
              :detailCallFunType="gateway_g1631.detailCallFunType"
              @handle_function_call="SendRequest1631"
              :refreshData="gateway_g1631.refreshData"
            ></list-table>
          </div>
        </b-tab>
        <b-tab
          @click="ClearError()"
          title="نیاز به تایید"
          href="#gateway_g1632"
        >
          <div>
            <list-table
              :url="gateway_g1632.url"
              title="نیاز به تایید"
              :fields="gateway_g1632.fields"
              :params="gateway_g1632.params"
              :detailUrl="gateway_g1632.detailUrl"
            ></list-table>
          </div>
        </b-tab>
        <b-tab
          title="نیاز به بروز رسانی"
          href="#gateway_update_required"
          @click="ClearError()"
        >
          <div>
            <b-alert variant="danger" :show="errors.length > 0">
              <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <b-alert variant="success" :show="success_errors.length > 0">
              <p v-for="x in success_errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <list-table
              :url="gateway_update_required.url"
              title="نیاز به بروز رسانی"
              :fields="gateway_update_required.fields"
              :params="gateway_update_required.params"
              :detailCallFun="gateway_update_required.detailCallFun"
              :detailCallFunType="gateway_update_required.detailCallFunType"
              @handle_function_call="gateway_update_required_func"
              :refreshData="gateway_update_required.refreshData"
            ></list-table>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
export default {
  name: "Merchants",
  data() {
    return {
      errors: [],
      success_errors: [],
      gateway_g1634: {
        refreshData: 0,
        detailCallFunType: "id",
        detailCallFun: "SendRequest1634",
        url: "paymentgateways?mdid20_request_status=1634",
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "user.name",
            label: "نام مالک درگاه",
            formatter(value, key, item) {
              return item.user.fa_name + " " + item.user.fa_family;
            },
          },
          {
            key: "acceptor_code",
            label: "کد پذیرنده",
          },
          {
            key: "website_name",
            label: "نام وبسایت",
          },
          {
            key: "website_en_name",
            label: "نام انگلیسی",
          },
          {
            key: "website",
            label: "آدرس",
          },
          {
            key: "statusName",
            label: "وضعیت",
            formatter: (value, key, item) => {
              return value;
            },
            tdClass: (value, key, item) => {
              return item.mdid19_status != 1580
                ? "text-success"
                : "text-danger";
            },
          },
          {
            key: "request_status.title",
            label: "وضعیت درخواست",
          },
          {
            key: "money_type.title",
            label: "واحد پولی",
          },
          {
            key: "user.confirmallstatus",
            label: "وضعیت احراز هویت",
            formatter: (value, key, item) => {
              return value == true ? "احراز شده" : "احراز نشده";
            },
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "نوع درگاه",
            field: "mdid12_money_type",
            type: "mddropdown",
            group: 12,
          },
        ],
      },
      gateway_g1628: {
        refreshData: 0,
        detailCallFunType: "id",
        detailCallFun: "SendRequest1628",
        url: "paymentgateways?mdid20_request_status=1628",
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "user.name",
            label: "نام مالک درگاه",
            formatter(value, key, item) {
              return item.user.fa_name + " " + item.user.fa_family;
            },
          },
          {
            key: "acceptor_code",
            label: "کد پذیرنده",
          },
          {
            key: "website_name",
            label: "نام وبسایت",
          },
          {
            key: "website_en_name",
            label: "نام انگلیسی",
          },
          {
            key: "website",
            label: "آدرس",
          },
          {
            key: "statusName",
            label: "وضعیت",
            formatter: (value, key, item) => {
              return value;
            },
            tdClass: (value, key, item) => {
              return item.mdid19_status != 1580
                ? "text-success"
                : "text-danger";
            },
          },
          {
            key: "request_status.title",
            label: "وضعیت درخواست",
          },
          {
            key: "money_type.title",
            label: "واحد پولی",
          },
          {
            key: "user.confirmallstatus",
            label: "وضعیت احراز هویت",
            formatter: (value, key, item) => {
              return value == true ? "احراز شده" : "احراز نشده";
            },
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "نوع درگاه",
            field: "mdid12_money_type",
            type: "mddropdown",
            group: 12,
          },
        ],
      },
      gateway_g1629: {
        refreshData: 0,
        detailCallFunType: "id",
        detailCallFun: "SendRequest1629",
        url: "paymentgateways?mdid20_request_status=1629",
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "user.name",
            label: "نام مالک درگاه",
            formatter(value, key, item) {
              return item.user.fa_name + " " + item.user.fa_family;
            },
          },
          {
            key: "acceptor_code",
            label: "کد پذیرنده",
          },
          {
            key: "website_name",
            label: "نام وبسایت",
          },
          {
            key: "website_en_name",
            label: "نام انگلیسی",
          },
          {
            key: "website",
            label: "آدرس",
          },
          {
            key: "statusName",
            label: "وضعیت",
            formatter: (value, key, item) => {
              return value;
            },
            tdClass: (value, key, item) => {
              return item.mdid19_status != 1580
                ? "text-success"
                : "text-danger";
            },
          },
          {
            key: "request_status.title",
            label: "وضعیت درخواست",
          },
          {
            key: "money_type.title",
            label: "واحد پولی",
          },
          {
            key: "user.confirmallstatus",
            label: "وضعیت احراز هویت",
            formatter: (value, key, item) => {
              return value == true ? "احراز شده" : "احراز نشده";
            },
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "نوع درگاه",
            field: "mdid12_money_type",
            type: "mddropdown",
            group: 12,
          },
        ],
      },
      gateway_g1630: {
        refreshData: 0,
        detailCallFunType: "id",
        detailCallFun: "SendRequest1630",
        url: "paymentgateways?mdid20_request_status=1630",
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "user.name",
            label: "نام مالک درگاه",
            formatter(value, key, item) {
              return item.user.fa_name + " " + item.user.fa_family;
            },
          },
          {
            key: "acceptor_code",
            label: "کد پذیرنده",
          },
          {
            key: "website_name",
            label: "نام وبسایت",
          },
          {
            key: "website_en_name",
            label: "نام انگلیسی",
          },
          {
            key: "website",
            label: "آدرس",
          },
          {
            key: "statusName",
            label: "وضعیت",
            formatter: (value, key, item) => {
              return value;
            },
            tdClass: (value, key, item) => {
              return item.mdid19_status != 1580
                ? "text-success"
                : "text-danger";
            },
          },
          {
            key: "request_status.title",
            label: "وضعیت درخواست",
          },
          {
            key: "money_type.title",
            label: "واحد پولی",
          },
          {
            key: "user.confirmallstatus",
            label: "وضعیت احراز هویت",
            formatter: (value, key, item) => {
              return value == true ? "احراز شده" : "احراز نشده";
            },
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "نوع درگاه",
            field: "mdid12_money_type",
            type: "mddropdown",
            group: 12,
          },
        ],
      },
      gateway_g1631: {
        refreshData: 0,
        detailCallFunType: "id",
        detailCallFun: "SendRequest1631",
        url: "paymentgateways?mdid20_request_status=1631",
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "user.name",
            label: "نام مالک درگاه",
            formatter(value, key, item) {
              return item.user.fa_name + " " + item.user.fa_family;
            },
          },
          {
            key: "acceptor_code",
            label: "کد پذیرنده",
          },
          {
            key: "website_name",
            label: "نام وبسایت",
          },
          {
            key: "website_en_name",
            label: "نام انگلیسی",
          },
          {
            key: "website",
            label: "آدرس",
          },
          {
            key: "statusName",
            label: "وضعیت",
            formatter: (value, key, item) => {
              return value;
            },
            tdClass: (value, key, item) => {
              return item.mdid19_status != 1580
                ? "text-success"
                : "text-danger";
            },
          },
          {
            key: "request_status.title",
            label: "وضعیت درخواست",
          },
          {
            key: "money_type.title",
            label: "واحد پولی",
          },
          {
            key: "user.confirmallstatus",
            label: "وضعیت احراز هویت",
            formatter: (value, key, item) => {
              return value == true ? "احراز شده" : "احراز نشده";
            },
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "نوع درگاه",
            field: "mdid12_money_type",
            type: "mddropdown",
            group: 12,
          },
        ],
      },
      gateway_g1632: {
        refreshData: 0,
        detailUrl: "editGateway",
        url: "paymentgateways?mdid20_request_status=1632",
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "user.name",
            label: "نام مالک درگاه",
            formatter(value, key, item) {
              return item.user.fa_name + " " + item.user.fa_family;
            },
          },
          {
            key: "acceptor_code",
            label: "کد پذیرنده",
          },
          {
            key: "website_name",
            label: "نام وبسایت",
          },
          {
            key: "website_en_name",
            label: "نام انگلیسی",
          },
          {
            key: "website",
            label: "آدرس",
          },
          {
            key: "statusName",
            label: "وضعیت",
            formatter: (value, key, item) => {
              return value;
            },
            tdClass: (value, key, item) => {
              return item.mdid19_status != 1580
                ? "text-success"
                : "text-danger";
            },
          },
          {
            key: "request_status.title",
            label: "وضعیت درخواست",
          },
          {
            key: "money_type.title",
            label: "واحد پولی",
          },
          {
            key: "user.confirmallstatus",
            label: "وضعیت احراز هویت",
            formatter: (value, key, item) => {
              return value == true ? "احراز شده" : "احراز نشده";
            },
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "نوع درگاه",
            field: "mdid12_money_type",
            type: "mddropdown",
            group: 12,
          },
        ],
      },
      gateway_update_required: {
        refreshData: 0,
        detailCallFunType: "id",
        detailCallFun: "gateway_update_required_func",
        url: "paymentgateways?update_required=1",
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "user.name",
            label: "نام مالک درگاه",
            formatter(value, key, item) {
              return item.user.fa_name + " " + item.user.fa_family;
            },
          },
          {
            key: "acceptor_code",
            label: "کد پذیرنده",
          },
          {
            key: "website_name",
            label: "نام وبسایت",
          },
          {
            key: "website_en_name",
            label: "نام انگلیسی",
          },
          {
            key: "website",
            label: "آدرس",
          },
          {
            key: "statusName",
            label: "وضعیت",
            formatter: (value, key, item) => {
              return value;
            },
            tdClass: (value, key, item) => {
              return item.mdid19_status != 1580
                ? "text-success"
                : "text-danger";
            },
          },
          {
            key: "update_required",
            label: "وضعیت به روز رسانی",
            formatter: (value, key, item) => {
              return value == 1 ? "نیاز به به روز رسانی" : "-";
            },
          },
          {
            key: "request_status.title",
            label: "وضعیت درخواست",
          },
          {
            key: "money_type.title",
            label: "واحد پولی",
          },
          {
            key: "user.confirmallstatus",
            label: "وضعیت احراز هویت",
            formatter: (value, key, item) => {
              return value == true ? "احراز شده" : "احراز نشده";
            },
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "نوع درگاه",
            field: "mdid12_money_type",
            type: "mddropdown",
            group: 12,
          },
        ],
      },
    };
  },
  components: {
    "list-table": TableShowData,
  },
  methods: {
    ClearError() {
      this.errors = [];
      this.success_errors = [];
    },
    SendRequest1634(item, type) {
      this.errors = [];
      this.success_errors = [];
      httpHelper
        .postData("MerchantRequest", {
          id: item.id,
          state: 0,
        })
        .then((res) => {
          if (res.success && res.result !== null) {
            this.gateway_g1634.refreshData =
              Math.floor(Math.random() * (100 - 1 + 1)) + 1;
            this.gateway_g1628.refreshData =
              Math.floor(Math.random() * (100 - 1 + 1)) + 1;
            this.success_errors.push("عملیات با موفقیت انجام شد");
          } else {
            if (res.error.errors && res.error.errors.length > 0) {
              for (var key in res.error.errors) {
                this.errors.push(res.error.errors[key]);
              }
              this.scrollTop();
            }
          }
        });
    },
    SendRequest1628(item, type) {
      this.errors = [];
      this.success_errors = [];
      httpHelper
        .postData("MerchantRequest", {
          id: item.id,
          state: 1,
        })
        .then((res) => {
          if (res.success && res.result !== null) {
            this.gateway_g1628.refreshData =
              Math.floor(Math.random() * (100 - 1 + 1)) + 1;
            this.gateway_g1629.refreshData =
              Math.floor(Math.random() * (100 - 1 + 1)) + 1;
            this.success_errors.push("عملیات با موفقیت انجام شد");
          } else {
            if (res.error.errors && res.error.errors.length > 0) {
              for (var key in res.error.errors) {
                this.errors.push(res.error.errors[key]);
              }
              this.scrollTop();
            }
          }
        });
    },
    SendRequest1629(item, type) {
      this.errors = [];
      this.success_errors = [];
      httpHelper
        .postData("MerchantRequest", {
          id: item.id,
          state: 2,
        })
        .then((res) => {
          if (res.success && res.result !== null) {
            this.gateway_g1629.refreshData =
              Math.floor(Math.random() * (100 - 1 + 1)) + 1;
            this.gateway_g1630.refreshData =
              Math.floor(Math.random() * (100 - 1 + 1)) + 1;
            this.gateway_g1631.refreshData =
              Math.floor(Math.random() * (100 - 1 + 1)) + 1;
            this.success_errors.push("عملیات با موفقیت انجام شد");
          } else {
            if (res.error.errors && res.error.errors.length > 0) {
              for (var key in res.error.errors) {
                this.errors.push(res.error.errors[key]);
              }
              this.scrollTop();
            }
          }
        });
    },
    SendRequest1630(item, type) {},
    SendRequest1631(item, type) {
      this.errors = [];
      this.success_errors = [];
      httpHelper
        .postData("MerchantRequest", {
          id: item.id,
          state: 4,
        })
        .then((res) => {
          if (res.success && res.result !== null) {
            this.gateway_g1631.refreshData =
              Math.floor(Math.random() * (100 - 1 + 1)) + 1;
            this.success_errors.push("عملیات با موفقیت انجام شد");
          } else {
            if (res.error.errors && res.error.errors.length > 0) {
              for (var key in res.error.errors) {
                this.errors.push(res.error.errors[key]);
              }
              this.scrollTop();
            }
          }
        });
    },
    gateway_update_required_func(item, type) {
      this.errors = [];
      this.success_errors = [];
      httpHelper.getData("updatemerchant/" + item.id).then((res) => {
        if (res.success && res.result !== null) {
          this.gateway_update_required.refreshData =
            Math.floor(Math.random() * (100 - 1 + 1)) + 1;
          this.success_errors.push("عملیات با موفقیت انجام شد");
        } else {
          if (res.error.errors && res.error.errors.length > 0) {
            for (var key in res.error.errors) {
              this.errors.push(res.error.errors[key]);
            }
            this.scrollTop();
          }
        }
      });
    },
    scrollTop: function() {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId);
        }
        window.scroll(0, window.pageYOffset - 50);
      }, 20);
    },
    scrollListener: function(e) {
      this.visible = window.scrollY > 150;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "درگاه های شاپرک",
      },
    ]);
  },
};
</script>
